var _line, _line2, _line3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntreruptorPentruOprireDeUrgenta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 36,
    x2: 21,
    y2: 36,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 36,
    x2: 33,
    y2: 36,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 36,
    x2: 45,
    y2: 36,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4715 36.5093C12.4715 37.6544 12.4892 38.7065 12.5053 39.6672C12.5354 41.4612 12.5602 42.9364 12.4546 44.103C12.3738 44.9958 12.2258 45.5297 12.0504 45.8204C11.9734 45.9481 11.906 46.0031 11.856 46.0315C11.8064 46.0597 11.7173 46.0941 11.547 46.0941C5.72207 46.0941 1 41.372 1 35.547C1 29.7221 5.72207 25 11.547 25C11.6382 25 11.6814 25.0213 11.7241 25.0555C11.7843 25.1039 11.8837 25.2169 11.992 25.462C12.2168 25.9708 12.371 26.7917 12.4531 27.9348C12.5625 29.4574 12.5342 31.3079 12.5033 33.34C12.4877 34.3571 12.4715 35.4196 12.4715 36.5093Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntreruptorPentruOprireDeUrgenta);
export default __webpack_public_path__ + "static/media/intreruptor_pentru_oprire_de_urgenta.d3cde88fc58167156ec9b10f10654080.svg";
export { ForwardRef as ReactComponent };